import BaseComponent from 'foundation/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

export default class PlayerHeroComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        
        this.init();
    }
   

    init() {
        if(this.refs.dateOfBirth){
            this.dateOfBirth = this.getAttribute(this.refs.dateOfBirth, 'options');
            this.age_latest = this.calculate_age(this.dateOfBirth);
            this.render(this.age_latest);
        }
        
        if(this.refs.randaid){
            this.randaID = this.getAttribute(this.refs.randaid, 'options');
            this.calculate_previousOpens(this.randaID, this.refs.randaid);
        }
       
    }

    render(age) {
        ReactDOM.render(
        <div class="player-hero-stats__val"> { age }</div>, 
        this.refs.dateOfBirth
        );
    };


    calculate_age (dob)  {
    const birthDate = new Date(dob); 
    const difference = Date.now() - birthDate.getTime();
    const age = new Date(difference);

    return Math.abs(age.getUTCFullYear() - 1970);
    }

    
    calculate_previousOpens(playerID, ref){
        var url=  "/api/PlayerHeroApi/GetPlayerStats"
        var data = {
           randaID: playerID
        };

      
        $.getJSON(url, data, function (result) {
            ReactDOM.render(
                <div class="player-hero-stats__val"> { result }</div>, 
                ref
                );
        });
    }
}